<template>
  <div class="view contentBody">
    <div class="title">退款单管理</div>
    <div class="content">
      <!-- <div class="notice">
        <p>
          <i class="el-alert__icon el-icon-warning"></i>商城功能未开启，如需在小程序展示商城，请先在“商城设置”中启用商城功能。
        </p>
      </div> -->
      <div class="condition">
        <div class="check_wrap">
          <el-radio-group v-model="formdata.type" @change="changetype" size="small">
            <el-radio-button
                    v-for="(item,index) in aftersaletype"
                    :label="item.value"
                    :key="index"
            >{{item.label}}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-input v-model="formdata.goods_name" placeholder="请输入售后单" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--<div class="other_wrap">-->
          <!--<el-button size="small">批量退款</el-button>-->
          <!--<el-button type="primary" size="small">导出</el-button>-->
        <!--</div>-->
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="refund_number" label="单价/申请数量">
            <template slot-scope="scope">{{scope.row.refund_price}}/{{scope.row.refund_number}}</template>
          </el-table-column>
          <el-table-column prop="refund_money" label="退款总价"></el-table-column>
          <el-table-column prop="refund_reason" label="退款原因"></el-table-column>
          <el-table-column prop="refund_remark" label="退款说明"></el-table-column>
          <el-table-column label="上传凭证">
            <template slot-scope="scope">
              <div
                      class="td_img"
                      v-if="scope.row.refund_evidence&&scope.row.refund_evidence.length>0"
              >
                <img :src="scope.row.refund_evidence[0]" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="card_id" label="名片主"></el-table-column>
          <el-table-column prop="consignee" label="收货人"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="orderdetail(scope.row)">查看订单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
                  background
                  :page-size="page.pagesize"
                  :current-page="page.pageindex"
                  layout="prev, pager, next"
                  :total="page.total"
                  @current-change="pageIndexChange"></el-pagination>
        </div>
      </div>
    </div>
    <!--<payDialog :visible.sync="paydialog" v-if="paydialog"></payDialog>-->
  </div>
</template>
<script>
  import payDialog from "@/components/dialog/payDialog.vue";
  import {pagination, aftersaletype} from "@/util/util.js";
  import api from '@/api.js'

  export default {
    name: "refundOrder",
    components: {
      payDialog
    },
    data() {
      return {
        aftersaletype: aftersaletype,
        formdata: {
          type: 0,
          refund_type: "",
          goods_name: ""
        },
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        value: "",
        option: [],
        radio1: "",
        tableData: [],
        paydialog: true
      };
    },
    created() {
      this.search();
    },
    methods: {
      //初始化请求
      search() {
        let loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.page.pageindex = 1;
        this.querylist(loading);
      },
      //查询列表
      querylist(loading) {
        let params = {
          page: this.page.pageindex,
          type: this.formdata.type,
          refund_type: this.formdata.refund_type,
          goods_name: this.formdata.goods_name
        };
        this.axios
            .post(api.refund_order_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list;
                this.page.total = response.data.all_page;
                loading.close();
              } else {
                this.page.total = 0;
              }
            })
            .catch(response => {
            });
      },
      // 切换类型查询
      changetype() {
        this.page.pageindex = 1;
        this.querylist();
      },
      orderdetail(option){
        this.$router.push({ name: "refundOrderDetail", query: { id: option.id } });
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.querylist();
      },
    }
  };
</script>
